import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';

export interface Props {}

const StudioProductsCatalogCardB: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId="7937b196-3bb6-42b3-93e9-ff7df06fc953"
  />
);
StudioProductsCatalogCardB.displayName = 'StudioProductsCatalogCardB';

export default StudioProductsCatalogCardB;
